export interface Portfolio {
	contact: number;
	portfolio: string;
	description: string;
	amount: number;
	currency: string;
}

export interface Transaction {
	userId:number;
	eqid:string;
	myDate:Date;
	order:number;
	description:string;
	currency:string;
	transactionPrice:number;
	date:Date;
	note:string;
	mdD:number;
	contactNumber:string;
	detail?: TransactionDetail;
}

export interface Trade {
	tradeDate: string;
	portfolio: null;
	type: string;
	asset: string;
	amount: number;
	price: number;
	volume: number;
	currency: string;
	settlementFee: number;
	tradeFee: number;
	thirdPartyFee: number;
	isin: string;
	industry: string;
	assetType: string;
	tradeDate2: string;
	detail?: TradeDetail;
}

export interface Asset {
	asset: string;
	originalSum: number;
	originalCurrency: string;
	sumEUR: number;
	currencyEUR: string;
	type: string;
	isin: null | string;
	count: number;
	price: number;
	pl: number;
	code: string;
	detail?: AssetDetail;
	transactions?: AssetTransaction[];
}

export interface AssetDetail {
	detail: AssetDetailInfo;
	graph: AssetGraphPoint[];
}

export interface AssetTransaction {
	dealId: number;
	date: Date;
	description: string;
	count: number;
	price: number;
	currency: string;
	volume: number;
}

export interface AssetDetailInfo {
	emitent: string;
	country: string;
	buyingPrice: number;
	profitLossPercentage: number;
	profitLossAbsolute: number;
	profitLossCoupon: number;
	coupon: null;
	maturity: Date;
	nominalValue: null;
	nextCouponDate: null;
}

export interface AssetGraphPoint {
	date: Date;
	conversionRate: number;
	dividend: null;
}

export enum TimeFilter {
	WEEK = "week",
	WEEKS_2 = "weeks_2",
	MONTH = "month",
	MONTHS_3 = "months_3",
	YEAR = "year",
	CUSTOM = "custom",
}

export interface AssetsGraphData {
	labels: string[];
	data: number[];
}

export interface AssetsGraphDataDual {
	datasets: number[][];
	labels: string[];
}

export interface AssetsHistory {
	date: string;
	amount: number;
	depositsAndWithdrawals: number | null;
	currency: string;
	summary: number | null;
}

export interface Params extends Record<string, string | number | boolean | Date | undefined> {}

export interface TransactionDetail {
	bankAccount:string;
	clientBankAccount:string;
	startDate:Date;
	endDate:Date;
	rate:number;
	expRateNetto:number;
	priceLocal:number;
	priceEur:number;
	pl:number;
	plEur:number;
	plPerc:number;
	plPercEur:number;
	dvd:number;
	dvdEur:number;
	couponDate:Date;
	volume:number;
	price:number;
	$settlementDate:Date;
	avgPrice:number;
	auv:number;
	thirdPartyFee:number;
}

export interface TradeDetail {
	isin: string;
	dealDate: Date;
	settlementDate: Date;
	type: string;
	industry: string;
	nominalValue: number;
}

export interface CompositionDetail {
	name: string;
	originalSum: number;
	originalCurrency: string;
	sumEUR: number;
	currencyEUR: string;
	ratio: number;
}
